import { createClient } from '@supabase/supabase-js';

// Frontend Supabase client for the standalone orbit-frontend app. Talks
// to the same self-hosted Supabase instance (auth + Postgres + RLS) that
// backs the Next.js Orbit build -- both frontends share one backend, one
// set of orbit_* tables, one auth.users pool. Passwordless (magic link /
// OTP code) auth only, matching the existing working flow.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.error('Missing REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
